export default __webpack_public_path__ + "static/media/white-freehand-line-measure-icon.c84cf46e.svg";